// Types pour les critères de propriété
export interface PropertyCriteria {
  id: string;
  label: string;
}

export type PropertyType = 'apartment' | 'house' | 'promotion' | 'land' | 'commercial';

export const propertyCriteria: Record<PropertyType, PropertyCriteria[]> = {
  apartment: [
    { id: 'hasElevator', label: 'Ascenseur' },
    { id: 'hasTerrace', label: 'Terrasse' },
    { id: 'hasGasHeating', label: 'Chauffage au gaz' },
    { id: 'isTopFloor', label: 'Dernier étage' },
    { id: 'hasGuardian', label: 'Gardien' },
    { id: 'hasDigicode', label: 'Digicode' },
    { id: 'hasDoubleGlazing', label: 'Double vitrage' },
    { id: 'hasRoofTerrace', label: 'Terrasse sur le toit' },
    { id: 'hasPool', label: 'Piscine' },
    { id: 'hasBalcony', label: 'Balcon' },
    { id: 'hasAirConditioning', label: 'Climatisation' },
    { id: 'isGroundFloor', label: 'Rez-de-chaussée' },
    { id: 'hasPrivateParking', label: 'Parking privé' },
    { id: 'hasIntercom', label: 'Interphone' },
    { id: 'hasCistern', label: 'Citerne' },
    { id: 'hasElectricShutters', label: 'Volets électriques' },
    { id: 'hasSeaView', label: 'Vue mer' }
  ],
  house: [
    { id: 'hasAirConditioning', label: 'Climatisation' },
    { id: 'hasBalcony', label: 'Balcon' },
    { id: 'hasClearView', label: 'Vue dégagée' },
    { id: 'hasParking', label: 'Parking' },
    { id: 'hasDoubleGlazing', label: 'Double vitrage' },
    { id: 'isRecentlyRenovated', label: 'Maison rénovée récemment' },
    { id: 'hasGasHeating', label: 'Chauffage au gaz' },
    { id: 'hasGuardian', label: 'Gardien' },
    { id: 'hasSchoolsNearby', label: 'Proximité école' },
    { id: 'hasTerrace', label: 'Terrasse' },
    { id: 'hasSeaView', label: 'Vue mer' },
    { id: 'hasPool', label: 'Piscine' },
    { id: 'hasGarage', label: 'Garage' },
    { id: 'hasElevator', label: 'Ascenseur' },
    { id: 'hasRoofTerrace', label: 'Terrasse sur le toit' },
    { id: 'hasElectricShutters', label: 'Volets électriques' },
    { id: 'hasShopsNearby', label: 'Proximité commerce' },
    { id: 'hasElectricGate', label: 'Portail électrique' }
  ],
  promotion: [
    { id: 'hasSeaView', label: 'Immeuble avec vue mer' },
    { id: 'hasClearView', label: 'Immeuble avec vue dégagée' },
    { id: 'hasGuardian', label: 'Gardien' },
    { id: 'hasIntercom', label: 'Interphone' },
    { id: 'hasDigicode', label: 'Digicode' },
    { id: 'hasElevator', label: 'Ascenseur' },
    { id: 'hasCommercialSpace', label: 'Immeuble avec commerce' },
    { id: 'hasShopsNearby', label: 'Proximité commerces' },
    { id: 'hasSchoolsNearby', label: 'Proximité écoles et universités' },
    { id: 'hasSharedPool', label: 'Piscine commune' },
    { id: 'hasGarden', label: 'Jardin commun ou privé' },
    { id: 'hasTerrace', label: 'Terrasse' },
    { id: 'hasAirConditioning', label: 'Climatisation' },
    { id: 'hasDoubleGlazing', label: 'Double vitrage' },
    { id: 'hasGasHeating', label: 'Chauffage au gaz' },
    { id: 'hasBalcony', label: 'Balcon' }
  ],
  land: [
    { id: 'hasPrivateAccess', label: 'Accès privé' },
    { id: 'hasBuildingPermit', label: 'Permis de construire' },
    { id: 'hasFencing', label: 'Clôturé' },
    { id: 'hasSchoolsNearby', label: 'Proximité écoles' },
    { id: 'hasShopsNearby', label: 'Proximité commerces' },
    { id: 'hasMainRoadsNearby', label: 'Proximité axes routiers' },
    { id: 'isEnclosed', label: 'Terrain clos' },
    { id: 'isBuildable', label: 'Constructible' },
    { id: 'isFlat', label: 'Terrain plat' },
    { id: 'hasUtilities', label: 'Viabilisé' },
    { id: 'hasClearView', label: 'Vue dégagée' },
    { id: 'hasSeaView', label: 'Vue mer' }
  ],
  commercial: [
    { id: 'hasGoodVisibility', label: 'Bonne visibilité' },
    { id: 'isBusyStreet', label: 'Rue passante' },
    { id: 'isCommercialArea', label: 'Zone commerciale' },
    { id: 'hasPublicTransportNearby', label: 'Proximité transports' },
    { id: 'hasDeliveryAccess', label: 'Accès livraison' },
    { id: 'hasGoodShopfront', label: 'Belle vitrine' },
    { id: 'hasParkingNearby', label: 'Parking à proximité' },
    { id: 'isGoodCondition', label: 'Bon état' },
    { id: 'hasToilets', label: 'Toilettes' },
    { id: 'hasAirConditioning', label: 'Climatisation' },
    { id: 'hasStorage', label: 'Espace stockage' }
  ]
};